import { cn } from '@/shadcn-ui/utils';
import { Link } from 'react-router';
import { useDisableSpaNavigation } from '@/util-react-router/hooks/use-disable-spa-navigation';

export default function Legalese() {
  const { disableSpaNavigation } = useDisableSpaNavigation();

  return (
    <p className={cn('homepage-footer self-stretch text-center text-flexcar-neutral60')}>
      &apos;Month-to-month car lease&apos; is a metaphor, not a legal lease, loan,
      financing agreement, or ownership option. For details on our services, insurance,
      maintenance, and roadside assistance coverage, see our{' '}
      <Link
        to="/membershipagreement"
        reloadDocument={disableSpaNavigation}
        className="link-body3 leading-[18px] text-flexcar-neutral60 decoration-flexcar-neutral60 hover:text-flexcar-neutral60"
      >
        Membership Agreement.
      </Link>
    </p>
  );
}
